import { Button } from 'antd';
import styled from 'styled-components';

import { aiPurple } from '../constants/colors';
export const SinapseButton: typeof Button = styled(Button)<{
  isPulsing?: boolean;
  type?: 'primary' | 'default';
}>`
  &&&,
  &&&[disabled] {
    box-shadow: 0 0 0 0 rgba(0, 0, 0, 1);
    background-color: ${aiPurple};
    color: white;
    transform: scale(1);
    ${(props) => (props.isPulsing ?? false ? 'animation: pulse 2s infinite;' : '')};
  }
  ${(props) =>
    props.type === 'primary'
      ? `
      &:hover {
        opacity: 0.9;
      }`
      : ''};

  @keyframes pulse {
    0% {
      transform: scale(0.95);
      box-shadow: 0 0 0 0 rgba(0, 0, 0, 0.7);
    }

    70% {
      transform: scale(1);
      box-shadow: 0 0 0 10px rgba(0, 0, 0, 0);
    }

    100% {
      transform: scale(0.95);
      box-shadow: 0 0 0 0 rgba(0, 0, 0, 0);
    }
  }
` as typeof Button;
